import moment from 'moment';

export const taskTitle = 'task';
export const overdueFieldKey = '0ed3';
export const startOfToday = moment().clone().startOf('day').format('YYYY-MM-DD');
export const activeTasksKey = 'activeTasks';
export const dueThisWeekKey = 'dueThisWeek';
export const overdueTasksKey = 'overdueTasks';
export const shouldReactQueryKeepPreviousData = true;
export const activeTasksLabel = 'In Progress or Open';
export const dueThisWeekLabel = 'Due This Week';
export const overdueLabel = 'Overdue';
